import React from "react";
import { Tag } from "component/shared/tag";

// A board that's waiting on paperwork approval: listings won't display until it's approved.
export const PendingTag: React.FC = () => <Tag label="Pending Approval" variant="neutral" size="small" />;
